import { render, staticRenderFns } from "./EditCase.vue?vue&type=template&id=6371ad3b&scoped=true"
import script from "./EditCase.vue?vue&type=script&lang=js"
export * from "./EditCase.vue?vue&type=script&lang=js"
import style0 from "./EditCase.vue?vue&type=style&index=0&id=6371ad3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371ad3b",
  null
  
)

export default component.exports